import { type AttributeInGroupResponse, type AttributeResponse, ROOT_STRUCT_CODE } from '@/entities/attributes';
import type { PredicateValue } from '@/entities/predicate';

/** Данные атрибута, которых хватает строке состава: справочник атрибутов за ней не стоит */
export type GroupAttributeValue = {
  code: string;
  /** Структура атрибута: вложенный атрибут, добавленный из своей карточки, отличается от корневого «тёзки» только ею */
  parentStructCode: string;
  name: string;
  description: string;
};

/** Оставляет только то, что показывает строка состава: источники разные — сама группа и окно добавления, хранимый вид один */
export const toGroupAttributeValue = (
  attribute: AttributeInGroupResponse | AttributeResponse,
): GroupAttributeValue => ({
  code: attribute.code,
  parentStructCode: attribute.parentStructCode ?? ROOT_STRUCT_CODE,
  name: attribute.name,
  description: attribute.description,
});

/** Атрибут состава называют код и структура: один код бывает у нескольких атрибутов */
export const isSameGroupAttribute = (a: GroupAttributeValue, b: GroupAttributeValue) =>
  a.code === b.code && a.parentStructCode === b.parentStructCode;

export type AttributeGroupFormValues = {
  name: string;
  code: string;
  description: string;
  attributes: GroupAttributeValue[];
  predicate: PredicateValue;
};
